module.exports = __webpack_public_path__ + "img/2-2.33f76893.png";